import {
	Tooth,
	ToothJaw,
	ToothPeriodontal,
	ToothSide,
} from '../../../../graphql/graphql';
import { getPeriodontalObjectWithTitle } from './getPeriodontalObjectWithTitle';
import {
	PeriodontalObject,
	PeriodontalSurface,
} from '../../Interfaces/PeriodontalObject.interface';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import { useDENTContext } from '../../Services/DENTContext';

const MIDDLE_PERIODONTAL_SURFACES: PeriodontalSurface[] = [
	'buccal',
	'lingual',
	'palatal',
];

function getJawDependingPeriodontalSurface(
	items: Record<PeriodontalSurface, PeriodontalObject>,
	tooth: Tooth,
) {
	const isLeft = tooth.side === ToothSide.Left;

	if (tooth.jaw === ToothJaw.Upper) {
		return isLeft
			? [items.distoPalatal, items.palatal, items.mesioPalatal]
			: [items.mesioPalatal, items.palatal, items.distoPalatal];
	}

	return isLeft
		? [items.distoLingual, items.lingual, items.mesioLingual]
		: [items.mesioLingual, items.lingual, items.distoLingual];
}

const filterMiddlePeriodontalObjects = (
	periodontalObjects: PeriodontalObject[],
) => {
	return periodontalObjects.filter(
		periodontalObject =>
			!MIDDLE_PERIODONTAL_SURFACES.includes(periodontalObject.type),
	);
};

export function getSideDependingPeriodontalObject(
	periodontal?: ToothPeriodontal,
	tooth?: Tooth,
) {
	if (!(periodontal && tooth)) {
		return [];
	}

	const { hideMiddlePeriodontalItems } = useDENTContext();

	const items = getPeriodontalObjectWithTitle(periodontal);
	const jawDependingSurfaces = getJawDependingPeriodontalSurface(items, tooth);

	const periodontalObjects =
		tooth.side === ToothSide.Right
			? [
					...jawDependingSurfaces,
					items.mesioBuccal,
					items.buccal,
					items.distoBuccal,
			  ]
			: [
					...jawDependingSurfaces,
					items.distoBuccal,
					items.buccal,
					items.mesioBuccal,
			  ];

	return hideMiddlePeriodontalItems
		? filterMiddlePeriodontalObjects(periodontalObjects)
		: periodontalObjects;
}
